var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconSendWhite = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.846,
    height: 11.846,
    viewBox: "0 0 11.846 11.846",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_near_me_24px",
    d: "M14.846,3,3,7.956V8.6l4.5,1.744,1.737,4.5h.645Z",
    transform: "translate(-3 -3)",
    fill: "#ffffff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconSendWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-send-white.5437a9cf917a8d0cd2b7b82982645d53.svg";